<script lang="ts">
export interface PhxsgCenterProps {
  id?: string;
  spacing?: '1' | '2' | '3' | '4' | '5' | '6' | '8' | '10' | '14' | '18';
  sizing?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  use?: keyof HTMLElementTagNameMap;
  intrinsic?: boolean;
  andText?: boolean;
}
</script>

<script setup lang="ts">
const {
  sizing = null,
  spacing = null,
  use = 'div',
  intrinsic = false,
  andText = false,
} = defineProps<PhxsgCenterProps>();
</script>

<template>
  <component
    :is="use"
    :id="id"
    :class="[
      'phxsg-center',
      {
        [`phxsg-center--spacing-${spacing}`]: spacing,
        [`phxsg-center--sizing-${sizing}`]: sizing,
        'phxsg-center--intrinsic': intrinsic,
        'phxsg-center--and-text': andText,
      },
    ]"
  >
    <slot />
  </component>
</template>

<style src="./center.css" />
